function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import React, { useMemo, Fragment, isValidElement, useEffect, useState } from "react";
import { injectTestId } from "@cvent/nucleus-test-automation";
import { UserIcon, CameraIcon, CheckIcon, HelpIcon, XIcon, SolidIcon } from "../components/icons";
import { useStyle } from "./Avatar.styles";
import { COLORS } from "../constants";
import composeEventHandlers from "../../../utils/composeEventHandlers";
var generateBackgroundColor = function(text) {
    var ref;
    return COLORS[((ref = text === null || text === void 0 ? void 0 : text.length) !== null && ref !== void 0 ? ref : 0) % 9];
};
var indicatorIcons = {
    check: CheckIcon,
    help: HelpIcon,
    x: XIcon,
    solid: SolidIcon
};
var getIndicatorIcon = function(param) {
    var icon = param.icon, iconProps = param.iconProps;
    var Icon = indicatorIcons[icon];
    if (Icon) {
        return _jsx(Icon, _objectSpread({}, iconProps));
    }
    return null;
};
export default function Avatar(_param) {
    var ariaLabelProp = _param.ariaLabel, backgroundColorOverride = _param.backgroundColorOverride, _border = _param.border, border = _border === void 0 ? false : _border, borderColorOverride = _param.borderColorOverride, _editScrim = _param.editScrim, editScrim = _editScrim === void 0 ? false : _editScrim, _formatTextOverride = _param.formatTextOverride, formatTextOverride = _formatTextOverride === void 0 ? '' : _formatTextOverride, hoverScrim = _param.hoverScrim, hoverShadow = _param.hoverShadow, image = _param.image, indicator = _param.indicator, _isLoading = _param.isLoading, isLoading = _isLoading === void 0 ? true : _isLoading, _isPortrait = _param.isPortrait, isPortrait = _isPortrait === void 0 ? false : _isPortrait, isRtl = _param.isRtl, onClick = _param.onClick, onError = _param.onError, onLoad = _param.onLoad, _size = _param.size, size = _size === void 0 ? 8 : _size, square = _param.square, testID = _param.testID, _text = _param.text, text = _text === void 0 ? '' : _text, _textColorOverride = _param.textColorOverride, textColorOverride = _textColorOverride === void 0 ? [] : _textColorOverride, _css = _param.css, _style = _param.style, _className = _param.className, rest = _objectWithoutProperties(_param, [
        "ariaLabel",
        "backgroundColorOverride",
        "border",
        "borderColorOverride",
        "editScrim",
        "formatTextOverride",
        "hoverScrim",
        "hoverShadow",
        "image",
        "indicator",
        "isLoading",
        "isPortrait",
        "isRtl",
        "onClick",
        "onError",
        "onLoad",
        "size",
        "square",
        "testID",
        "text",
        "textColorOverride",
        "css",
        "style",
        "className"
    ]);
    var backgroundColor = backgroundColorOverride || generateBackgroundColor(text);
    var ref;
    var ref1 = useStyle({
        backgroundColor: backgroundColor,
        border: border,
        borderColorOverride: borderColorOverride,
        formatTextOverride: formatTextOverride,
        editScrim: editScrim,
        hoverScrim: hoverScrim,
        hoverShadow: hoverShadow,
        isRtl: isRtl,
        size: size,
        length: (ref = formatTextOverride === null || formatTextOverride === void 0 ? void 0 : formatTextOverride.length) !== null && ref !== void 0 ? ref : 0,
        square: square,
        indicator: indicator,
        textColorOverride: textColorOverride
    }), wrapper = ref1.wrapper, mainContainer = ref1.mainContainer, imageContainer = ref1.imageContainer, loadingImageContainer = ref1.loadingImageContainer, actionContainer = ref1.actionContainer, actionIcon = ref1.actionIcon, indicatorContainer = ref1.indicatorContainer;
    var ariaLabel = ariaLabelProp || ((indicator === null || indicator === void 0 ? void 0 : indicator.fallBackText) ? "".concat(text, " - ").concat(indicator.fallBackText) : text);
    var _icon;
    return _jsxs("div", _objectSpread({}, injectTestId(testID), {
        css: wrapper,
        tabIndex: onClick ? 0 : undefined,
        "aria-label": ariaLabel,
        onClick: onClick
    }, rest, {
        role: rest.role || (ariaLabel || rest['aria-label'] ? 'img' : undefined),
        children: [
            _jsxs("div", {
                css: mainContainer,
                children: [
                    _jsx(AvatarImage, {
                        formatTextOverride: formatTextOverride,
                        image: image,
                        imageContainer: imageContainer,
                        isLoading: isLoading,
                        isPortrait: isPortrait,
                        loadingImageContainer: loadingImageContainer,
                        onError: onError,
                        onLoad: onLoad,
                        testID: testID,
                        text: text,
                        textColor: mainContainer === null || mainContainer === void 0 ? void 0 : mainContainer.color
                    }),
                    editScrim && _jsxs(Fragment, {
                        children: [
                            _jsx("div", {
                                css: actionContainer
                            }),
                            _jsx("span", {
                                css: actionIcon,
                                children: _jsx(CameraIcon, {})
                            })
                        ]
                    })
                ]
            }),
            indicator && _jsx("div", {
                css: indicatorContainer,
                children: getIndicatorIcon({
                    icon: (_icon = indicator.icon) !== null && _icon !== void 0 ? _icon : 'check',
                    iconProps: {
                        fill: indicatorContainer === null || indicatorContainer === void 0 ? void 0 : indicatorContainer.color
                    }
                })
            })
        ]
    }));
};
function AvatarImage(param) {
    var formatTextOverride = param.formatTextOverride, image = param.image, imageContainer = param.imageContainer, initialLoading = param.isLoading, isPortrait = param.isPortrait, loadingImageContainer = param.loadingImageContainer, onError = param.onError, onLoad = param.onLoad, testID = param.testID, text = param.text, textColor = param.textColor;
    var ref3 = _slicedToArray(useState(initialLoading), 2), isLoading = ref3[0], setIsLoading = ref3[1];
    var ref2 = _slicedToArray(useState(false), 2), imageHasError = ref2[0], setImageHasError = ref2[1];
    useEffect(function() {
        if (image) {
            setImageHasError(false);
        }
    }, [
        image
    ]);
    var formattedContent = useMemo(function() {
        if (formatTextOverride) return formatTextOverride;
        if (!text) {
            return _jsx(UserIcon, {
                fill: textColor
            });
        }
        var ref = _slicedToArray(text.split(' '), 2), firstName = ref[0], lastName = ref[1];
        var firstInitial = firstName.slice(0, 1).toUpperCase();
        var lastInitial = lastName ? lastName.slice(0, 1).toUpperCase() : '';
        return "".concat(firstInitial).concat(lastInitial);
    }, [
        formatTextOverride,
        text,
        textColor
    ]);
    var setNoError = function() {
        setImageHasError(false);
        setIsLoading(false);
    };
    var setHasError = function() {
        return setImageHasError(true);
    };
    var renderedImage = image && typeof image === 'string' ? _jsx("img", _objectSpread({}, injectTestId(testID ? "".concat(testID, "-image") : undefined), {
        onLoad: composeEventHandlers(onLoad, setNoError),
        onError: composeEventHandlers(onError, setHasError),
        css: [
            isLoading ? loadingImageContainer : imageContainer
        ],
        src: image,
        alt: "".concat(text)
    })) : isValidElement(image) && image;
    return _jsxs(_Fragment, {
        children: [
            (isLoading || !image || imageHasError) && _jsx(_Fragment, {
                children: formattedContent
            }),
            !imageHasError && renderedImage
        ]
    });
}
